import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CountdownComponent',
  props: {
    time: {
      type: Number,
      default: 0,
    },
  },
  emits: ['countdownend'],
  setup(__props, { emit }) {

const props = __props

  const MILLISECONDS_SECOND = 1000;
  const MILLISECONDS_MINUTE = 60 * MILLISECONDS_SECOND;
  const MILLISECONDS_HOUR = 60 * MILLISECONDS_MINUTE;
  const EVENT_VISIBILITY_CHANGE = 'visibilitychange';
  const INTERVAL = 1000;

  

  

  const totalMilliseconds = ref<number>(0);
  const endTime = ref<number>(0);
  const requestId = ref<number>(0);

  const minutes = computed(() => {
    return String(
      Math.floor(
        (totalMilliseconds.value % MILLISECONDS_HOUR) / MILLISECONDS_MINUTE,
      ),
    ).padStart(2, '0');
  });

  const seconds = computed(() => {
    return String(
      Math.floor(
        (totalMilliseconds.value % MILLISECONDS_MINUTE) / MILLISECONDS_SECOND,
      ),
    ).padStart(2, '0');
  });

  function progress() {
    totalMilliseconds.value -= INTERVAL;
    continueCountdown();
  }

  function continueCountdown() {
    const delay = Math.min(totalMilliseconds.value, INTERVAL);
    if (delay > 0) {
      let init: number;
      let prev: number;
      const step = (now: number) => {
        if (!init) {
          init = now;
        }

        if (!prev) {
          prev = now;
        }

        const range = now - init;

        if (
          range >= delay ||
          // Avoid losing time about one second per minute (now - prev ≈ 16ms) (#43)
          range + (now - prev) / 2 >= delay
        ) {
          progress();
        } else {
          requestId.value = requestAnimationFrame(step);
        }

        prev = now;
      };

      requestId.value = requestAnimationFrame(step);
    } else {
      totalMilliseconds.value = 0;
      emit('countdownend');
    }
  }

  function updateCountdown() {
    totalMilliseconds.value = Math.max(0, endTime.value - Date.now());
  }

  function pauseCountdown() {
    cancelAnimationFrame(requestId.value);
  }

  function handleVisibilityChange() {
    switch (document.visibilityState) {
      case 'visible':
        updateCountdown();
        continueCountdown();
        break;

      case 'hidden':
        pauseCountdown();
        break;

      default:
    }
  }

  onMounted(() => {
    totalMilliseconds.value = props.time;
    endTime.value = Date.now() + props.time;
    continueCountdown();

    document.addEventListener(EVENT_VISIBILITY_CHANGE, handleVisibilityChange);
  });

  onBeforeUnmount(() => {
    document.removeEventListener(
      EVENT_VISIBILITY_CHANGE,
      handleVisibilityChange,
    );
    pauseCountdown();
  });

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    minutes: _unref(minutes),
    seconds: _unref(seconds)
  })
}
}

})